import type { ComponentChildren, JSX } from "preact";

type IconProps = {
  size?: number;
  class?: string;
  title?: string;
};

function Svg({
  size = 20,
  class: className,
  title,
  children,
}: IconProps & { children: ComponentChildren }): JSX.Element {
  return (
    <svg
      class={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}

const stroke = {
  stroke: "currentColor",
  "stroke-width": 1.5,
  "stroke-linecap": "round" as const,
  "stroke-linejoin": "round" as const,
};

export function IconArrow(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M5 12h14M13 6l6 6-6 6" {...stroke} />
    </Svg>
  );
}

export function IconSearch(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="11" cy="11" r="6.25" {...stroke} />
      <path d="M16 16l4 4" {...stroke} />
    </Svg>
  );
}

export function IconClose(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M6 6l12 12M18 6L6 18" {...stroke} />
    </Svg>
  );
}

export function IconMap(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="8.25" {...stroke} />
      <circle cx="12" cy="12" r="3.25" {...stroke} />
      <path d="M12 3.75v2.5M12 17.75v2.5M3.75 12h2.5M17.75 12h2.5" {...stroke} />
    </Svg>
  );
}

export function IconList(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M8 7h12M8 12h12M8 17h12" {...stroke} />
      <circle cx="4.5" cy="7" r="1.15" fill="currentColor" />
      <circle cx="4.5" cy="12" r="1.15" fill="currentColor" />
      <circle cx="4.5" cy="17" r="1.15" fill="currentColor" />
    </Svg>
  );
}

export function IconCheck(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M5 12.5l4.2 4.2L19 7.5" {...stroke} />
    </Svg>
  );
}
